import { useState } from "react";

const faqs = [
  {
    q: "糖果直播是什么平台？",
    a: "糖果直播是一个专注于直播资讯和内容推荐的平台。我们汇集了最新的直播行业动态、精选栏目推荐、实用教程指南以及平台动态，帮助用户高效获取直播相关的优质内容。无论你是直播爱好者还是内容创作者，都能在这里找到有价值的信息。",
  },
  {
    q: "糖果直播提供直播服务吗？",
    a: "糖果直播本身不提供直播服务，我们是一个直播资讯聚合平台。我们收集和整理来自各大直播平台的优质内容和行业资讯，帮助用户发现好的直播栏目、学习直播技巧、了解行业动态。",
  },
  {
    q: "如何在糖果直播上找到感兴趣的内容？",
    a: "你可以通过首页的分类导航快速定位感兴趣的内容类型。我们提供直播资讯、栏目推荐、使用教程、平台动态四大分类，每个分类下都有丰富的内容。你也可以使用搜索功能或浏览首页的精选推荐和最新文章。",
  },
  {
    q: "糖果直播的内容多久更新一次？",
    a: "我们的编辑团队每天都会更新内容，确保您能获取到最新、最热的直播资讯。重大行业动态和平台活动我们会第一时间进行报道。",
  },
  {
    q: "我想学习直播，从哪里开始？",
    a: "推荐从使用教程分类开始，特别是新手必看系列文章，涵盖了设备选购、平台选择、内容策划、直播技巧等全方位的入门知识。此外，栏目推荐分类中也有很多优质直播栏目可以参考学习。",
  },
];

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于糖果直播，你想了解的都在这里
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <div
                  className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? "max-h-96 pb-5 px-5" : "max-h-0"
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}